var Backbone = require('backbone');
var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');
var SubSectionDummy = require('front/pages/Section/SubSectionDummy');

var Submissions = require('submissions/pages/Submissions/Submissions');

var EligiblePopup = require('front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup');
var SubmissionPopup = require('submissions/pages/SubmissionPopup/SubmissionPopup');
var MaterialsPopup = require('submissions/pages/MaterialsPopup/MaterialsPopup');

var Rules = require('submissions/pages/Rules/Rules');
var Help = require('submissions/pages/Help/Help');
var Profile = require('submissions/pages/Profile/Profile');

var Service = require('submissions/pages/Service/Service');

require('submissions/components/MobileWarning/MobileWarning.less');

var ANIMATION_DURATION = 500;

module.exports = Backbone.Router.extend({
    routes: {
        '': 'submissions',

        'eligible-projects/:category/': 'eligiblePopup',
        'submission/:category/': 'submissionPopup',
        'submission/:category/:id/': 'submissionEditPopup',
        'submission/:category/:id/uploads/': 'submissionUploadsPopup',
        'materials/:category/': 'materialsPopup',

        'rules-and-specifications(/)': 'rules',
        'help(/)': 'help',
        'profile(/)': 'profile',

        'closed(/)': 'closed',
        'create-account(/)': 'create',
        'create-account/:hash(/)': 'create',
        'forgot(/)': 'forgot',
        'login(/)': 'login',
        'reset/:code(/)': 'reset'
    },


    //checks if routes to another view (not one currently active) and reloads the page,
    //it's important for search requests, which can be made from any page, including search page by itself
    route: function (route, name, callback) {
        var router = this;
        if (!callback) callback = this[name];

        var f = function () {
            var currentViewClass = app.state.currentViewClass;
            var forceReload = false;

            //execute route callback
            //try is for some views that can't render itself property in SPA mode (members for example)
            //so next code with reload wasn't executed
            try {
                callback.apply(router, arguments);
            } catch (error) {
                //forceReload = true;
            }

            if (forceReload || (currentViewClass && currentViewClass != app.state.currentViewClass)) {
                $('body').hide(); //prevent empty page render as SPA (reload doesn't refresh page immediately)
                console.warn('fuck!!!');
                window.location.reload();
            } else {
                this.trackSPAPageView();
            }
        };

        return Backbone.Router.prototype.route.call(this, route, name, f);
    },


    trackSPAPageView: function () {
        var loc = location.pathname + location.search + location.hash;

        this.visitedPages = this.visitedPages || {};

        //do not track first route, ga will track it by itself on initialization
        if (this.notFirstRoute && !this.visitedPages[loc]) {
            //simply set ga('send', 'pageview', [page]) is not recommended
            //because base url doesn't changed and all subsequent events (if any and if they are not pageview)
            //will fire for initial url on wivh page was loaded
            //https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications

            // new gtag handles route change by itself (should be created special trigger inside)
            // window.ga && ga('set', 'page', loc);
            // window.ga && ga('send', 'pageview');
        }

        this.notFirstRoute = true;
        this.visitedPages[loc] = true;
    },


    submissions: function () {
        //in some cases we need page reload to update its info
        //in case of availability change
        //in case of profile changes
        if (this.needReloadPages && this.needReloadPages.submissions) {
            window.location.reload();

            return;
        }

        this.activate(Submissions, {view: SubSectionDummy, viewData: {}});
    },


    eligiblePopup: function (category) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['submissions:rules']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Rules, {view: EligiblePopup, viewData: {
            category: category,
            parent: 'rules'
        }});
    },


    submissionPopup: function (category, id) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['submissions:submissions']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Submissions, {view: SubmissionPopup, viewData: {
            category: category,
            onlyUploads: false,
            id: id
        }});
    },


    submissionEditPopup: function (category, id) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['submissions:submissions']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Submissions, {view: SubmissionPopup, viewData: {
            category: category,
            onlyUploads: false,
            id: id
        }});
    },


    submissionUploadsPopup: function (category, id) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['submissions:submissions']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Submissions, {view: SubmissionPopup, viewData: {
            category: category,
            onlyUploads: true,
            id: id
        }});
    },


    materialsPopup: function (category) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['submissions:submissions']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Submissions, {view: MaterialsPopup, viewData: {category: category}});
    },


    rules: function () {
        this.activate(Rules, {view: SubSectionDummy, viewData: {}});
    },


    help: function () {
        this.activate(Help, {view: SubSectionDummy, viewData: {}});
    },


    profile: function () {
        this.activate(Profile, {view: SubSectionDummy, viewData: {}});
    },


    closed: function () {
        this.activate(Service, {view: SubSectionDummy, viewData: {
            state: 'closed'
        }});
    },


    create: function (hash) {
        this.activate(Service, {view: SubSectionDummy, viewData: {
            state: 'create',
            hash: hash
        }});
    },


    forgot: function () {
        this.activate(Service, {view: SubSectionDummy, viewData: {
            state: 'forgot'
        }});
    },


    login: function () {
        this.activate(Service, {view: SubSectionDummy, viewData: {
            state: 'login'
        }});
    },


    reset: function (code) {
        this.activate(Service, {view: SubSectionDummy, viewData: {
            state: 'reset',
            code: code
        }});
    },


    navigateBack: function () {
        Backbone.history.navigate(this.history[this.history.length - 1], {trigger: 'true'});
        this.history.pop(); //pop, after Backbone.history.navigate onroute listener add return url to history stack, remove it
    },


    activate: function (view, params) {
        params = params || {};

        // view is rendered on server
        if (!app.state.view) {
            params.server = true;
            params.inAnimated = false;
            app.state.viewConstructor = view;
            app.state.view = new view(params);
            app.state.view.activate();
            app.state.currentViewClass = view;

            return;
        }

        app.state.prevView = app.state.view;
        //this.activateStandardLogic(view, params);
        //return;
        if (this.isSectionLogic(app.state.prevView, view, params)) {
            this.activateSectionLogic(params);
        } else {
            this.activateStandardLogic(view, params);
        }

        app.state.currentViewClass = view;
    },

    // navigation activation with full page reload with loader
    activateStandardLogic: function (view, params) {
        var newParams = _.defaults({server: false, inAnimated: true}, params);
        app.state.viewConstructor = view;

        var newView = new view(newParams);
        var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;
        var self = this;

        return Promise.all([app.state.view.playOut({duration: duration, zoom: params.zoomNavigate, view: newView}), newView.loadData()])
            .then(function () {
                app.els.$content.css({minHeight: app.els.$content.height()});

                return app.state.view.deactivate({destroy: true});
            })
            .then(function () {
                app.state.isServer = false;
                app.state.view = newView;
                app.state.view.activate(newParams)
                    .then(function () {
                        app.els.$content.css({minHeight: ''});
                        $(window).scrollTop(0);

                        return app.state.view.playIn({duration: duration, zoom: params.zoomNavigate, view: newView});
                    });
            });
    },

    // navigation activation with popup
    activateSectionLogic: function (subSectionParams) {
        var view = subSectionParams.view;
        var params = _.omit(subSectionParams, 'view');
        params.server = false;
        params.inAnimated = true;
        app.state.view.update(view, params);
        app.state.isServer = false;
    },


    isSectionLogic: function (prevView, view, params) {
        return app.state.prevView instanceof Section && app.state.prevView.constructor === view;
        //return app.state.prevView instanceof Section && view === Section;
    },


    onNeedReloadMessage: function (page) {
        this.needReloadPages = this.needReloadPages || {};

        this.needReloadPages[page] = true;
    },


    start: function () {
        var is404 = app.els.$body.hasClass('Page404');

        $('body').css('opacity', ''); //body is invisible at first state, to prevent menu blinking for service pages show

        $(window).on('resize', function () {
            if (app.settings.isPhone || window.outerWidth < (app.settings.isDesktop ? 800 : 768)) {
                $('.Content, .Footer').hide();
                $('.MobileWarning').show();
            } else {
                $('.Content, .Footer').show();
                $('.MobileWarning').hide();
            }
        });

        $(window).resize();

        app.vent.on('need-reload', this.onNeedReloadMessage.bind(this));

        this.history = [];

        this.listenTo(this, 'route', function (name, args) {
            //do not store popup urls in history, to force popup close to underlying page (even if there is a sequence of opened popups, especially years on awards)
            if (/Popup$/.test(name)) return;

            this.history.push(Backbone.history.fragment);
        }.bind(this));

        //If you'd like to use pushState, but have browsers that don't support it natively
        //use full page refreshes instead, you can add {hashChange: false} to the options.
        //for ie 9 mainly
        Backbone.history.start({
            pushState: true,
            hashChange: false,
            silent: is404
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/Router.js
// module id = 73
// module chunks = 0